const load_more_partners = () => {
    var visibleCards = 9;
    var cardsIncrement = 3;

    $('.partner-card:gt(' + (visibleCards - 1) + ')').hide();

    $('button').on('click', function () {
        $('.partner-card:lt(' + (visibleCards + cardsIncrement) + ')').fadeIn();

        visibleCards += cardsIncrement;

        if (visibleCards >= $('.partner-card').length) {
            $('.load-more').hide();
        }
    });
}

export default load_more_partners;